import type { GeoData } from '@smg-real-estate/geo-libs';
import type { GeoLocationType } from '@smg-real-estate/geo-libs/dist/types/geo-location';
import type { SmgSplitSession } from '@smg-real-estate/vue-experiments';
import type { SSRContext } from 'vue/server-renderer';

import {
  CANTON_MIN_ZOOM_DESKTOP,
  CANTON_MIN_ZOOM_MOBILE,
  MUNICIPALITY_MIN_ZOOM_DESKTOP,
  MUNICIPALITY_MIN_ZOOM_MOBILE,
  TOWN_MIN_ZOOM_DESKTOP,
  TOWN_MIN_ZOOM_MOBILE,
  ZIPTOWN_MIN_ZOOM_DESKTOP,
  ZIPTOWN_MIN_ZOOM_MOBILE,
} from './utils/constants';

export enum ViewMode {
  Map = 'map',
  Data = 'data',
}

export enum EventSource {
  Init = 'init', // server side transition
  Map = 'map', // click the area on map
  Search = 'search', // choose a location from Search bar
  Reload = 'reload', // change language
  Reset = 'reset', // reset to country level
}

export enum propertyCategory {
  apartment = 6,
  house = 5,
}

export enum MapGeoLevel {
  Country = 'country',
  Canton = 'canton',
  Municipality = 'municipality',
  Town = 'ziptown',
}

export enum MapLayerSource {
  Canton = 'cantonData',
  Municipality = 'municipalityData',
  Town = 'zipTownData',
}

export enum MapLayerName {
  CantonTileSet = 'MarketAtlasCantons',
  MunicipalityTileSet = 'MarketAtlasMunicipalities',
  TownTileSet = 'MarketAtlasTowns',
}

export enum MapLayerHighlightName {
  CantonHighlight = 'MarketAtlasCantons-Highlight',
  MunicipalityHighlight = 'MarketAtlasMunicipalities-High',
  TownHighlight = 'MarketAtlasTowns-Highlight',
}

export const MIN_SEARCH_TEXT_LENGTH = 2;

export const ENABLED_GEO_LEVELS: Array<GeoLocationType> = ['canton', 'municipality', 'ziparea'];

export const ZOOM_CONFIG: {
  largeScreen: { [key in MapGeoLevel]: number };
  noneLargeScreen: { [key in MapGeoLevel]: number };
} = {
  largeScreen: {
    country: CANTON_MIN_ZOOM_DESKTOP,
    canton: MUNICIPALITY_MIN_ZOOM_DESKTOP,
    municipality: TOWN_MIN_ZOOM_DESKTOP,
    ziptown: ZIPTOWN_MIN_ZOOM_DESKTOP,
  },
  noneLargeScreen: {
    country: CANTON_MIN_ZOOM_MOBILE,
    canton: MUNICIPALITY_MIN_ZOOM_MOBILE,
    municipality: TOWN_MIN_ZOOM_MOBILE,
    ziptown: ZIPTOWN_MIN_ZOOM_MOBILE,
  },
};

export enum GeoIdLevels {
  Country = 'country',
  Canton = 'canton',
  Municipality = 'municipality',
  Town = 'ziparea',
}

export interface FeatureFlagsResponse {
  smgSplitSession: SmgSplitSession;
}

export interface AppSSRContext extends SSRContext {
  url: string;
  geoData: GeoData;
  smgSplitSession: SmgSplitSession;
}

export const FLAGSET_PROPERTY_VALUATION = 'valuation';
